/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { dFix } from '@/data/Settings';
import { GTMRemoveFromCartPayload } from '@/data/types/GTM';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import getValueByPathFromUnknown from 'integration/utils/getValueByPathFromUnknown';

export const getGTMRemoveFromCartEventData = async (payload: GTMRemoveFromCartPayload) => {
	const { name, partNumber, currency = '', quantity, attributes, productPrice, keyword } = payload;
	const affiliation = 'Dportenis'; // This should be the Seller Organization name

	const brand = findProductAttribute(attributes ?? [], 'Marca')?.value;
	const size = getValueByPathFromUnknown(attributes, ['Talla']);

	const product = {
		partNumber,
		name,
		quantity: dFix(quantity, 0),
		currency,
		price: productPrice?.offer,
		category: '',
		keyword,
		affiliation,
		productPrice,
		brand,
		size,
	};

	return product;
};
